import { Dialog, DialogContent } from '../../../../common/components/ui/dialog';
import type { ReactNode } from 'react';
import { CartDialogCopyExistingOrder } from './CartDialogCopyExistingOrder.tsx';
import { getLogger } from '../../../../logging/logger';
import { type CartBusyDialogDescriptor } from '../../state-hooks/useCartIsBusy';

const clientLog = getLogger('cart-progress-dialog');

type CartBusyDialogProp = {
  busyDialogContentDescriptor: CartBusyDialogDescriptor;
};

export function CartBusyDialog({ busyDialogContentDescriptor }: Readonly<CartBusyDialogProp>) {
  if (!busyDialogContentDescriptor) {
    return null;
  }

  let dialogContent: ReactNode;

  switch (busyDialogContentDescriptor) {
    case 'COPY_ORDER':
      dialogContent = <CartDialogCopyExistingOrder source="order" />;
      break;
    case 'COPY_SALESORDERSET':
      dialogContent = <CartDialogCopyExistingOrder source="salesorderset" />;
      break;
    case 'COPY_TEMPLATE':
      dialogContent = <CartDialogCopyExistingOrder source="template" />;
      break;
    default: {
      clientLog.error('CartBusyDialog: unhandled dialogContentDescriptor:', busyDialogContentDescriptor);
      return null;
    }
  }

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent
        showFullscreenOnMobile
        className="max-w-5xl desktop:max-w-2xl w-full"
        showClose={false}
        aria-describedby={undefined} // unterdrückt Warnung in Browser Dev Console
        data-testid={'cart-dialog'}
      >
        {dialogContent}
      </DialogContent>
    </Dialog>
  );
}
